import type { RuleDefinition } from '../domain/types';
import { finding, isCellBlank } from './helpers';

export const BQ002: RuleDefinition = {
  id: 'BQ002',
  name: '计量单位缺失',
  description: '检查清单明细行是否缺少计量单位。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: ['unit'],
  message: '明细行的计量单位为空。',
  suggestion: '请根据原清单口径补充计量单位。',
  check: ({ detailRows }) =>
    detailRows.filter((row) => isCellBlank(row, 'unit')).map((row) => finding(row, 'unit')),
};
